import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const VISUAL_RULE_EDITOR_CLASS_NAME = 'VisualRuleEditor';
export const VISUAL_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type VisualRuleEditorClassSlot =
	(typeof VISUAL_RULE_EDITOR_CLASS_SLOTS)[number];

export interface VisualRuleEditorClasses {
	root: string;
}

export type VisualRuleEditorClassKey = keyof VisualRuleEditorClasses;

export const getVisualRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(VISUAL_RULE_EDITOR_CLASS_NAME, slot);

export const visualRuleEditorClasses: VisualRuleEditorClasses =
	generateUtilityClasses(VISUAL_RULE_EDITOR_CLASS_NAME, ['root']);

export default visualRuleEditorClasses;
